import script from "./botao-menu-admin.vue?vue&type=script&setup=true&lang=js"
export * from "./botao-menu-admin.vue?vue&type=script&setup=true&lang=js"

import "./botao-menu-admin.vue?vue&type=style&index=0&id=59512287&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59512287"]])

export default __exports__